import { List, Create, Edit } from "../Components/index";

export default [
    {
        path: "/admin/office-appointment",
        component: List,
        name: "office-appointment-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/office-appointment/:id/edit",
        component: Edit,
        name: "office-appointment-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/office-appointment/create",
        component: Create,
        name: "office-appointment-create",
        meta: {
            requiresAuth: true,
        },
    },
];
